export default {
	document_buzzwords_label: 'Schlagworte',
	document_category_create_error: 'Die Kategorie konnte nicht angelegt werden.',
	document_category_created: 'Kategorie wurde angelegt.',
	document_category_global_hint: 'global',
	document_category_label: 'Kategorie',
	document_category_new_button: 'Neue Kategorie',
	document_category_new_dialog_title: 'Neue Kategorie anlegen',
	document_category_new_for_ido: 'Für diese Akte',
	document_category_new_global: 'Für alle Akten (global)',
	document_category_new_name_label: 'Name der Kategorie',
	document_category_new_scope_label: 'Gültig für',
	document_category_none: 'Keine Kategorie',
	document_create_dialog_camera: 'Kamera',
	document_create_dialog_cancel: 'Abbrechen',
	document_create_dialog_create_new_document: 'Neue Dokumente einstellen',
	document_create_dialog_create_new_document_source: 'Quelle',
	document_create_dialog_mediathek: 'Mediathek',
	document_create_dialog_select_files: 'Dateien auswählen',
	document_create_dialog_selected_files: 'Ausgewählt',
	document_create_dialog_upload_error: 'Das Dokument konnte nicht hochgeladen werden.',
	document_create_dialog_upload_file: 'Datei hochladen',
	document_create_dialog_upload_files: 'Dateien hochladen',
	document_create_dialog_uploading: 'Lade hoch …',
	document_default_postbox_label: 'Standardablage',
	document_delete_dialog_confirm_cancel_label: 'Nein',
	document_delete_dialog_confirm_message: 'Möchten Sie dieses Dokument wirklich löschen?',
	document_delete_dialog_confirm_ok_label: 'Ja',
	document_delete_dialog_confirm_title: 'Dokument löschen',
	document_delete_failed_notification: 'Das Dokument konnte nicht gelöscht werden',
	document_download: 'Herunterladen',
	document_download_to_documents_successful: 'Die Datei wurde erfolgreich in den Ordner Dokumente geladen',
	document_external_share_active: 'Aktiv',
	document_external_share_apply: 'Übernehmen',
	document_external_share_cancel: 'Abbrechen',
	document_external_share_copied: 'Link kopiert',
	document_external_share_copy: 'Link kopieren',
	document_external_share_copy_failed: 'Kopieren nicht möglich — bitte den Link manuell markieren und kopieren.',
	document_external_share_delete: 'Link löschen',
	document_external_share_delete_confirm_header: 'Link löschen?',
	document_external_share_delete_confirm_message:
		'Der Link wird sofort ungültig. Bereits verschickte Links funktionieren dann nicht mehr.',
	document_external_share_delete_failed: 'Der Link konnte nicht gelöscht werden.',
	document_external_share_deleted: 'Link gelöscht',
	document_external_share_discard_confirm_message: 'Nicht übernommene Änderungen verwerfen?',
	document_external_share_download_notice: 'Der Dokument-Autor wird über jeden externen Download benachrichtigt.',
	document_external_share_empty_description:
		'Jeder, der den Link erhält, kann die Datei ohne Anmeldung herunterladen. Optional können Sie den Link mit Passwort und Ablaufdatum schützen.',
	document_external_share_empty_headline: 'Dokument per Link extern teilen',
	document_external_share_expired_on: 'Abgelaufen am {date}',
	document_external_share_generate: 'Link erzeugen',
	document_external_share_generate_failed: 'Der Link konnte nicht erzeugt werden.',
	document_external_share_link_label: 'Link',
	document_external_share_menu_external: 'Extern teilen',
	document_external_share_menu_internal: 'Teilen',
	document_external_share_password: 'Passwort',
	document_external_share_settings_save_failed: 'Die Einstellungen konnten nicht gespeichert werden.',
	document_external_share_settings_saved: 'Einstellungen gespeichert',
	document_external_share_share_link: 'Link teilen…',
	document_external_share_title: 'Extern teilen',
	document_external_share_valid_until: 'Gültig bis',
	document_external_share_valid_until_hint: 'Leer = unbegrenzt gültig',
	document_file_label: 'Datei',
	document_pdf_zoom: 'PDF-Zoom',
	document_pdf_zoom_in: 'PDF vergrößern',
	document_pdf_zoom_out: 'PDF verkleinern',
	document_pdf_zoom_value: 'Zoom {value}%',
	document_postbox_label: 'Dokumentenablage',
	document_preview_load_failed: 'Die Vorschau konnte nicht geladen werden',
	document_save_failed_notification: 'Das Dokument konnte nicht gespeichert werden',
	document_saved_notification: 'Das Dokument wurde gespeichert',
	document_share: 'Teilen…',
	document_title_label: 'Dokumenten Titel',
	document_upload_tray_dismiss: 'Verwerfen',
	document_upload_tray_failed: 'Fehlgeschlagen',
	document_upload_tray_failed_title: '{failed} von {total} fehlgeschlagen',
	document_upload_tray_phase_preparing: 'Vorbereiten …',
	document_upload_tray_phase_processing: 'Verarbeitet …',
	document_upload_tray_retry: 'Erneut versuchen',
	document_upload_tray_title: 'Lade {current} von {total} hoch',
	document_upload_tray_toggle: 'Dateien anzeigen',
	document_version_author: 'Von',
	document_version_delete: 'Version löschen',
	document_version_delete_failed: 'Die Version konnte nicht gelöscht werden.',
	document_version_delete_initial_not_possible: 'Die Originalversion kann nicht gelöscht werden',
	document_version_dialog_camera: 'Kamera',
	document_version_dialog_cancel: 'Abbrechen',
	document_version_dialog_confirm_cancel_label: 'Nein',
	document_version_dialog_confirm_message: 'Möchten Sie diese Version wirklich löschen?',
	document_version_dialog_confirm_ok_label: 'Ja',
	document_version_dialog_confirm_title: 'Dokumentversion löschen',
	document_version_dialog_create_new_document: 'Neue Version einstellen',
	document_version_dialog_create_new_document_source: 'Quelle',
	document_version_dialog_mediathek: 'Mediathek',
	document_version_dialog_select_files: 'Datei auswählen',
	document_version_dialog_selected_files: 'Ausgewählt',
	document_version_dialog_upload_error: 'Die Dokumentversion konnte nicht hochgeladen werden.',
	document_version_dialog_upload_file: 'Datei hochladen',
	document_version_dialog_upload_files: 'Dateien hochladen',
	document_version_dialog_uploading: 'Lade hoch …',
	document_version_download: 'Version herunterladen',
	document_version_drag_message: 'Drag & Drop Dokument hier ablegen',
	document_version_drop_message: 'Dokument fallen lassen',
	document_version_filename: 'Dateiname',
	document_version_filesize: 'Größe',
	document_version_selected_new_document: 'Dokument auswählen',
	document_version_time: 'Zeit',
	document_version_title: 'Dokumentversionen',
	document_version_version: 'Version',
	document_version_versions: 'Versionen',
};
